import { render } from "./notification.vue?vue&type=template&id=fb9a2b60"
import script from "./notification.js?vue&type=script&lang=js&external"
export * from "./notification.js?vue&type=script&lang=js&external"

import "./notification.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__